import { render } from "./CharactersList.vue?vue&type=template&id=e6ae680a"
import script from "./CharactersList.vue?vue&type=script&lang=js"
export * from "./CharactersList.vue?vue&type=script&lang=js"

import "./CharactersList.vue?vue&type=style&index=0&id=e6ae680a&lang=css"
script.render = render

export default script